<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2780_215346)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 6.2H15.5C18.151 6.2 20.3 8.34903 20.3 11C20.3 13.651 18.151 15.8 15.5 15.8H6.5C3.84903 15.8 1.7 13.651 1.7 11C1.7 8.34903 3.84903 6.2 6.5 6.2ZM0 11C0 7.41015 2.91015 4.5 6.5 4.5H15.5C19.0898 4.5 22 7.41015 22 11C22 14.5899 19.0899 17.5 15.5 17.5H6.5C2.91015 17.5 0 14.5899 0 11ZM15.3593 7.5C13.4263 7.5 11.8593 9.067 11.8593 11C11.8593 12.933 13.4263 14.5 15.3593 14.5C17.2923 14.5 18.8593 12.933 18.8593 11C18.8593 9.067 17.2923 7.5 15.3593 7.5Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2780_215346">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
